<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img :src="appLogoImage" alt="pb logo" class="logo" />
        <h2 class="brand-text text-primary ml-1">RecurringTasks</h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Unsubscribe" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Unsubscribe Content-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            Email Notifications
          </b-card-title>

          <div v-if="loading">
            <div class="text-center my-3">
              <b-spinner label="Loading..." />
              <p class="mt-2">Processing your request...</p>
            </div>
          </div>

          <div v-else-if="error">
            <b-alert show variant="danger" class="my-2">
              <h4 class="alert-heading">Error</h4>
              <div class="alert-body">
                {{ errorMessage }}
              </div>
            </b-alert>
            <p class="mt-2">
              If you need assistance, please contact your administrator.
            </p>
          </div>

          <div v-else-if="success">
            <b-alert show variant="success" class="my-2">
              <h4 class="alert-heading">Unsubscribed Successfully</h4>
              <div class="alert-body">
                You have been successfully unsubscribed from weekly reminder
                emails.
              </div>
            </b-alert>
            <p class="mt-2">
              You can resubscribe to email notifications anytime from your
              profile settings.
            </p>
          </div>

          <div v-else>
            <b-card-text class="mb-2">
              You are about to unsubscribe from weekly reminder emails for
              <strong>{{ email }}</strong
              >.
            </b-card-text>
            <b-button variant="primary" block @click="unsubscribe">
              Confirm Unsubscribe
            </b-button>
          </div>

          <div class="text-center mt-5" v-if="success || error">
            <b-button variant="outline-secondary" to="/">
              Return to Home
            </b-button>
          </div>
        </b-col>
      </b-col>
      <!-- /Unsubscribe Content-->
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BLink,
  BCardText,
  BCardTitle,
  BImg,
  BButton,
  BSpinner,
  BAlert,
} from "bootstrap-vue"
import { $themeConfig } from "@themeConfig"
import store from "@/store"

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCardText,
    BCardTitle,
    BImg,
    BButton,
    BSpinner,
    BAlert,
  },
  data() {
    return {
      sideImg: require("@/assets/images/pages/login-v2.svg"),
      loading: false,
      success: false,
      error: false,
      errorMessage: "",
      token: null,
      tenantId: null,
      email: null,
    }
  },
  setup() {
    const { appLogoImage } = $themeConfig.app
    return {
      appLogoImage,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        return require("@/assets/images/pages/login-v2-dark.svg")
      }
      return this.sideImg
    },
  },
  created() {
    // Get token, tenantId, and email from query parameters
    this.token = this.$route.query.token
    this.tenantId = this.$route.query.tenantId
    this.email = this.$route.query.email

    if (!this.token || !this.tenantId || !this.email) {
      this.error = true
      this.errorMessage =
        "Invalid or missing unsubscribe parameters. Make sure you clicked the exact link from your email."
    }
  },
  methods: {
    async unsubscribe() {
      try {
        this.loading = true

        const url = process.env.VUE_APP_API_BASE_URL + "/user/unsubscribe"

        // Send all three pieces of information to the backend
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Tenant-Id": this.tenantId, // Add tenant ID to header
          },
          body: JSON.stringify({
            token: this.token,
            tenantId: this.tenantId,
            email: this.email,
          }),
        })

        const data = await response.json()

        if (!response.ok) {
          throw new Error(
            data.message || "An error occurred while processing your request."
          )
        }

        this.success = true
      } catch (err) {
        this.error = true
        this.errorMessage =
          err.message || "An error occurred while processing your request."
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../@core/scss/vue/pages/page-auth";

.logo {
  width: 20px;
  height: 15px;
  box-shadow: 0px;
  align-self: flex-start;
}
</style>
